import React, { useEffect } from 'react';
import { Icon } from '../components/Icon';
import { Section } from '../components/Section';
import { BRAZE_EVENT } from '../constants/braze';
import { Bridge } from '../plugins/bridge';
import { ContentInfoEventProperties, ContentTabEventProperties } from '../types/amplitudeEventProperties';
import {ReactComponent as Insta} from "../assets/svg/Social_instagram.svg";
import {ReactComponent as Facebook} from "../assets/svg/Social_facebook.svg";
import {ReactComponent as Youtube} from "../assets/svg/Social_Youtube.svg";
import {ReactComponent as Pinterest} from "../assets/svg/Social_Pinterest.svg";
import {ReactComponent as SoundCloud} from "../assets/svg/Icons_Social.svg";

const SOCIAL_INFO = [
  {
    Icon: Insta,
    size: 'wh-10',
    link: 'https://www.instagram.com/carharttwip_kr/?hl=ko',
  },
  {
    Icon: Facebook,
    size: 'wh-9',
    link: 'https://www.facebook.com/carharttwipkr/',
  },
  {
    Icon: Youtube,
    size: 'wh-9',
    link: 'https://www.youtube.com/user/carharttwipkr/featured',
  },
  {
    Icon: Pinterest,
    size: 'wh-9',
    link: 'https://www.pinterest.co.kr/carharttwip/',
  },
  {
    Icon: SoundCloud,
    size: 'wh-9',
    link: 'https://soundcloud.com/carharttwip',
  },
];

function onClickSocialLink(link : string) {
  switch(link) {
    case 'https://www.instagram.com/carharttwip_kr/?hl=ko' :
      Bridge.sendAmplitude('social_link_icon_clicked', {social_link_icon : 'instagram'});
      break;

    case 'https://www.facebook.com/carharttwipkr/' :
      Bridge.sendAmplitude('social_link_icon_clicked', {social_link_icon : 'facebook'});
      break;

    case 'https://www.youtube.com/user/carharttwipkr/featured' :
      Bridge.sendAmplitude('social_link_icon_clicked', {social_link_icon : 'youtube'});
      break;

    case 'https://www.pinterest.co.kr/carharttwip/' :
      Bridge.sendAmplitude('social_link_icon_clicked', {social_link_icon : 'pinterest'});
      break;

    case 'https://soundcloud.com/carharttwip' :
      Bridge.sendAmplitude('social_link_icon_clicked', {social_link_icon : 'soundcloud'});
      break;

    default : return;
  }
}

export const BrandPage = () => {

  useEffect(() => {
    const contentEventProperties : ContentTabEventProperties = {
      content_tab : "브랜드"
    }
    Bridge.sendAmplitude('content_list_page_viewed', contentEventProperties);  
  }, []);

  return (
    <div className="pt-11 md:pl-20 pb-20">
      <h1 style={{}} className="text-30 md:text-72 font-bold">
        하나의 브랜드 - 두개의 이야기
      </h1>

      <div className="flex space-x-6 items-center py-8">
        <p className="text-12 text-gray-400">30-Oct-2018</p>
        <div className="brand_hover cursor-pointer relative">
          <Icon.Share className="wh-4 float-left share_b" />
          <div className="flex absolute -right-40 -top-1.5 brand_hover2 px-3">
            {SOCIAL_INFO.map((item, index) => {
              const { link, Icon, size } = item;
              return (
                  <a
                      href={link}
                      target="_blank"
                      rel="noopener noreferrer"
                      key={link}
                      onClick={()=>{onClickSocialLink(link)}}
                  >
                    <Icon className="wh-7" />
                  </a>
              );
            })}
          </div>
        </div>
      </div>

      <Section className="grid md:grid-cols-2 md:gap-14 max-w-3xl mx-auto">
        <div className="flex flex-col space-y-8">
          <img
            src="https://www.carhartt-wip.com/binaries/content/gallery/carhartt/brand/fw21_one_brand_two_stories.jpg"
            alt=""
            className=""
          />

          <p className="text-12 font-bold leading-loose">
            칼하트는 미국에서 BIB(가슴 부분에 사각형 또는 직사각형의
            가슴바대와 어깨끈이 달린 바지)를 제조하기 시작한지 100여년이 지난
            후부터 이 클래식한 제품들을 수정 보완하여 유럽 소비자들에게 칼하트윕
            제품을 소개하기 시작하였습니다. 오늘날 칼하트윕은 미국
            칼하트의 정체성과 근본을 유지하며, 브랜드의 상징적인 제품들을 더
            정제되고 세련된 디자인과 스타일로 소개합니다.
          </p>

          <button
              style={{ backgroundColor: '#3E53BB' }}
              className="px-5 py-3 rounded-md text-white w-max"
              onClick={() => { brand_clicked("칼하트윕", "https://www.carhartt-wip.com/en") }}
          >
            칼하트윕
          </button>
        </div>

        <div className="flex flex-col space-y-8 pt-32">
          <img
            src="https://www.carhartt-wip.com/binaries/content/gallery/carhartt/brand/carhartt_2.jpg"
            alt=""
            className=""
          />

          <p className="text-12 font-bold leading-loose">
            칼하트의 창업자인 헤밀턴 칼하트는 독창적인 사고자이며, 무한한
            창조가였습니다. 무엇보다도 한번도 한적이 없는 일에 대해 시도
            해보고자 하고 이루어질 것이라고 믿는 사람이었으며, 그가 만드는
            제품들에 대한 큰 자신감과 믿음이 있는 사람이었습니다. “스퀘어 라벨을
            착용한 분들에 대하여 이야기하자면, 그 분들은 나를 위해서 일하시던지
            혹은 내게서 제품을 사가시는 분들이다”라는 말처럼, 단순히 워크웨어
            브랜드를 만들었던 것이 아니라 129년 이상 굳건히 유지된 강한
            유대관계를 만들었던 것입니다. 오늘날, 칼하트는 헤밀턴의 이러한
            정신을 함께하고자 하는 모든 사람들을 위한 브랜드입니다.
          </p>

          <button
            style={{ backgroundColor: '#3E53BB' }}
            className="px-5 py-3 rounded-md text-white w-max"
            onClick={() => { brand_clicked("칼하트", "https://www.carhartt.com/") }}
          >
            칼하트
          </button>
        </div>
      </Section>

      <Section>
        <h2 className="text-48 font-bold text-center py-28 italic leading-normal ">
          “누군가 나를 위해 일하거나, 나에게서 사는 것과 상관없이 모든 이들을
          공정하게 대하라.”
        </h2>

        <p className="text-brand-1 text-14 max-w-3xl m-auto leading-6">
          칼하트의 창업자인 Hamilton 칼하트는 독창적인 사고자이며, 무한한
          창조가였습니다. 무엇보다도 한번도 한적이 없는 일에 대해 시도 해보고자
          하고 이루어질 것이라고 믿는 사람이었으며, 그가 만드는 제품들에 대한 큰
          자신감과 믿음이 있는 사람이었습니다. “스퀘어 라벨을 착용한 분들에
          대하여 이야기하자면, 그 분들은 나를 위해서 일하시던지 혹은 내게서
          제품을 사가시는 분들이다”라는 말처럼, 단순히 워크웨어 브랜드를
          만들었던 것이 아니라 129년 이상 굳건히 유지된 강한 유대관계를 만들었던
          것입니다. 오늘날, 칼하트는 Hamilton의 이러한 정신을 함께하고자 하는
          모든 사람들을 위한 브랜드입니다.
        </p>
      </Section>
    </div>
  );
};

function brand_clicked(brand_name: string, link: string) {
  const content = {
    content_tab: "브랜드",
    content_id: brand_name,
    content_name: brand_name,
    url: link
  }

  Bridge.sendAmplitude('content_clicked', content);
  window.open(link, '_blank');
}